export interface News {
  newsId: string;
  newsTitle: string;
  newsSummary: string;
  description: string;
  startPublicationDate: string;
  endPublicationDate: string;
  argument: string;
  inProduction: boolean;
  numberOfClicks: number;
  notification: number;
  isNotification: boolean;
  labNews: number;
  activeLabBanner: boolean;
  type: number;
  thumbnailPhoto: string;
  secondThumbnailPhoto: string;
  newsSubject: number;
  labelSubjectNews: string;
}
